import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { columns } from "../../utils/columns";
import { ROWS_PER_PAGE } from "src/constants/rowPerPage";
import { PAGE, LIMIT } from "src/constants/searchParams";
import { PatientTableRow } from "./components/PatientTableRow";
import { PatientProfile } from "src/api/types";
import { Box } from "@mui/material";
import { useMemo } from "react";
import { useFilters } from "src/hooks/useFilters";
import { useBatchFilters } from "src/hooks/useBatchFilters";
import TableHeaderCell from "src/shared/TableHeaderCell";

interface Props {
  patients: PatientProfile[];
  total: number;
}

function PatientsTable({ patients, total }: Props) {
  const [limit] = useFilters(LIMIT, ROWS_PER_PAGE[0].toString());
  const [page, setPage] = useFilters(PAGE, "0");
  const batchUpdate = useBatchFilters();

  //104 header + filters
  //64 gaps
  //32 top and bottom padding
  const height = useMemo(() => window.innerHeight - 104 - 64 - 32, []);

  const handleChangePage = (_: unknown, newPage: number) => {
    setPage(newPage.toString());
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    batchUpdate((p) => {
      p.set(LIMIT, event.target.value);
      p.set(PAGE, "0");
      return p;
    });
  };

  return (
    <Box>
      <TableContainer sx={{ height: height - 52 - 2 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableHeaderCell key={column.id} column={column} />
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {patients.map((row) => (
              <PatientTableRow key={row.id} row={row} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        sx={{ height: 52, mr: 10 }}
        showFirstButton
        showLastButton
        rowsPerPageOptions={ROWS_PER_PAGE}
        component="div"
        count={total}
        rowsPerPage={Number(limit)}
        page={Number(page)}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  );
}

export default PatientsTable;
